/**
 * If the next query appears in the store or there are not more connections that
 * are using the previous query we should send "Unsubscribe" message
 * @param {string | undefined} nextQueryID ID in the store of the currently applied query
 * @param {string | undefined} prevQuery The previous query from the store
 * @returns {boolean}
 */
export function shouldUnsubscribe(store, nextQueryID, prevQuery) {
    return typeof nextQueryID !== "undefined" || (typeof prevQuery !== "undefined" &&
        // No more connections are using the previous query
        store.getConnectionsForQuery(prevQuery).length === 0);
}
//# sourceMappingURL=shouldUnsubscribe.js.map